import { render, staticRenderFns } from "./ChangeEmailModal.vue?vue&type=template&id=0b45ac44&"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports